// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Heh3","col":"CardReaderDesc_col__6Lypz","label":"CardReaderDesc_label__2Se6G"};